import { DictionaryAutocomplete, useStaticListSource } from '@eas/common-web';
import { Language } from '@enums';

export function useLanguages() {
  return useStaticListSource<DictionaryAutocomplete>([
    { id: Language.CZECH, name: 'Česky' },
    { id: Language.ENGLISH, name: 'Anglicky' },
    { id: Language.GERMAN, name: 'Německy' },
    { id: Language.SLOVAK, name: 'Slovensky' },
    { id: Language.UKRAINIAN, name: 'Ukrajinsky' },
  ]);
}
